<template>
  <div class="p-8" :style='"padding-bottom: 0;color:"+data.style.color'>
    <div class="bor-rad-10 s_over_h p-8"
      :style="'background: linear-gradient(90deg, '+data.style.bgColor.left+' 0%, '+data.style.bgColor.right+' 100%);'">
      <p class="fz-15 s_font_b">{{data.style.receiveTitle}}</p>
      <div class="">
        <div class="s_flex_bian_c p-t-10 p-b-10">
          <img class="width-65 height-65 bor-rad-5" style="object-fit:cover;width:65px" src="@/assets/images/normal.png" alt="">
          <div class="width73">
            <p class="fz-13 m-b-15 s_omit">原透明质酸补水精华面膜 6种透明质酸渗透至
              肌肤深层进行充分补水</p>
            <div class="s_flex_bian_c">
              <!-- <p class="fz-12 height-25 width-50 s_flex_center" style="border-radius: 3px;background: #484D62;">剩10个</p> -->
              <p></p>
              <p class="height-25 p-l-8 p-r-8 fz-12 bor-rad-15 s_flex_center"
                style="background: linear-gradient(90deg, #D6A465 0%, #F6D7AA 100%);color:#916022">
                <DownloadOutlined style='color:#916022;font-size: 14px;' />立即领取
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { ref } from "vue";
  import store from "@/store";
  import { DownloadOutlined } from "@ant-design/icons-vue";
  export default {
    components: { DownloadOutlined },
    props: { data: Object },
    name: "receive",
    setup() {
      return {
        info: ref(store.state.user.info)
      }
    }
  };
</script>
<style>

</style>